import Link from "@/components/ui/RouterLink";
import { ArrowRight, MessageSquare } from "lucide-react";

export function FinalCTA() {
  return (
    <section className="relative overflow-hidden bg-gradient-brand py-20">
      <svg className="absolute inset-0 h-full w-full opacity-20" aria-hidden="true">
        <defs>
          <pattern id="cta-grid" width="42" height="42" patternUnits="userSpaceOnUse">
            <path d="M 42 0 L 0 0 0 42" fill="none" stroke="white" strokeWidth="0.5" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#cta-grid)" />
      </svg>

      <div className="relative mx-auto max-w-3xl px-5 text-center lg:px-8">
        <h2 className="font-display text-3xl font-semibold text-white sm:text-4xl">
          Ready to Build on Better Infrastructure?
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-white/85 sm:text-base">
          Explore available products or speak with our team about the right server, cloud, email
          or network solution for your business.
        </p>
        <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
          <Link
            href="/#products"
            className="focus-ring inline-flex items-center justify-center gap-2 rounded-full bg-white px-6 py-3.5 text-sm font-medium text-navy transition hover:bg-white/90"
          >
            Explore Products <ArrowRight className="h-4 w-4" />
          </Link>
          <Link
            href="/contact"
            className="focus-ring inline-flex items-center justify-center gap-2 rounded-full border border-white/40 px-6 py-3.5 text-sm font-medium text-white transition hover:bg-white/10"
          >
            <MessageSquare className="h-4 w-4" /> Talk to an Expert
          </Link>
        </div>
      </div>
    </section>
  );
}
